import resolveArrayValue from 'css-in-js-utils/lib/resolveArrayValue';
import isPlainObject from 'isobject';

function resolveFallbackValues(style) {
  for (var property in style) {
    var value = style[property];

    if (Array.isArray(value)) {
      style[property] = resolveArrayValue(property, value);
    } else if (isPlainObject(value) && property !== 'fontFace') {
      style[property] = resolveFallbackValues(value);
    }
  }

  return style;
}

export default (function () {
  return resolveFallbackValues;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-fallback-value/es/index.js
// module id = 297
// module chunks = 0